import moment from 'moment';
import React, { ChangeEvent, useEffect, useState } from 'react';
import PhoneInput from 'react-phone-number-input';

import {
  Line,
  LoadsTitle,
  LoadsFlex,
  CheckBoxItem,
  CheckBoxSquare,
  CustomCheckBoxSquare,
  LoadsInputField,
  LoadsInputFieldHalf,
  LoadsInputFieldThird,
  InputDiv,
  LoadsInput,
  LoadsInputTextArea,
  LoadsLabel,
  LoadsText,
  SelectedValue,
  FieldIcon,
  LoadsSelect,
  Opt,
  InputDate,
  Bottom,
  Actions,
  Cancel,
  Error,
  Header,
  Main,
  Wrapper,
} from './pointModal.style';
import americaStates from '../../../../americaStates.json';
import { getLoadData, Pickup, updatePickup } from '../../../../API/loads';
import { Calendar, Check, SelectArrow } from '../../../../assets/icons';
import Button from '../../../../components/Button/Button';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { resetError } from '../../../../store/slices/loadsSlice';
import ModalPortal from '../../ModalPortal';

const defaultErrorState = {
  message: '',
  errors: {
    business_name: [],
    street_address: [],
    city: [],
  },
};

type ModalAssignProps = {
  close: () => void;
  pickupData: Pickup;
  refPickup: any;
  pickedAt: string;
};

const PointPickup: React.FC<ModalAssignProps> = ({ close, pickupData, refPickup, pickedAt }) => {
  const dispatch = useAppDispatch();

  const { loadId, loadInfo, error } = useAppSelector((state: { loads: any }) => state.loads);

  const [err, setErr] = useState(error ?? defaultErrorState);
  const [copyToCustomer, setCopyToCustomer] = useState<boolean>(false);
  const [pointDate, setPointDate] = useState<Date | null>(() => {
    const src = pickupData?.date;
    if (!src) {
      return null;
    }
    const parsed = moment(src);
    return parsed.isValid() ? parsed.toDate() : null;
  });
  const [customDate, setCustomDate] = useState<Date | null>(() => {
    const src = pickupData?.custom_date ?? pickupData?.created_at;
    return src ? moment(src).toDate() : null;
  });
  const initialShowTime = pickupData.custom_date_format === 'datetime';
  const [showCustomTime, setShowCustomTime] = useState<boolean>(initialShowTime);

  const [loadPoint, setLoadPoint] = useState({
    businessNamePoint: pickupData.business_name,
    streetAddressPoint: pickupData.street_address,
    cityPoint: pickupData.city,
    zipPoint: pickupData.zip ? pickupData.zip : '',
    buyerNumberPoint: pickupData.buyer_number ? pickupData.buyer_number : '',
    notesPoint: pickupData.notes ? pickupData.notes : '',
    fullNamePoint: pickupData.full_name ? pickupData.full_name : '',
    emaiPoint: pickupData.email ? pickupData.email : '',
    use_custom_date: pickupData.use_custom_date ? pickupData.use_custom_date : false,
    created_at: pickupData.created_at ? pickupData.created_at : '',
    custom_date: pickupData.custom_date ? pickupData.custom_date : '',
  });

  useEffect(() => {
    setShowCustomTime(pickupData.custom_date_format === 'datetime');
  }, [pickupData]);

  useEffect(() => {
    return () => {
      dispatch(resetError());
    };
  }, []);

  const [statePoint, setStatePoint] = useState<string>(pickupData.state);
  const [phonePoint, setPhonePoint] = useState<string>(pickupData.phone ? pickupData.phone : '');

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>, setState: any, name: any, state: any) => {
    if (name === 'businessNamePoint')
      setState({
        ...state,
        [name]: e.target.value.replace(/[^A-Za-z\s]/gi, ''),
      });
    else if (name === 'cityPoint')
      setState({
        ...state,
        [name]: e.target.value.replace(/[^A-Za-z\s]/gi, ''),
      });
    else if (name === 'fullNamePoint')
      setState({
        ...state,
        [name]: e.target.value.replace(/[^A-Za-z\s]/gi, ''),
      });
    else if (name === 'use_custom_date')
      setState({
        ...state,
        [name]: e.target.checked,
      });
    else if (name === 'custom_date')
      setState({
        ...state,
        [name]: e,
      });
    else setState({ ...state, [name]: e?.target?.value });
  };

  const changeSelectState = (e: React.ChangeEvent<HTMLSelectElement>, setState: any, setStateIndex?: any) => {
    setState(e.target.value);
    setStateIndex(e.currentTarget.selectedOptions[0].dataset.value);
  };

  const handleInputTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>, setState: any, name: any, state: any) =>
    setState({ ...state, [name]: e.target.value });

  const handleCheckboxCopy = (e: React.ChangeEvent<HTMLInputElement>, setState: any, elem: any) => {
    setState(!elem);
  };

  const handleConfirm = async () => {
    const custom_date_format = showCustomTime ? 'datetime' : 'date';

    const custom_date =
      loadPoint.use_custom_date && customDate
        ? showCustomTime
          ? moment(customDate).format('YYYY-MM-DDTHH:mm:ssZ')
          : moment(customDate).format('YYYY-MM-DD')
        : undefined;
    const res: any = await dispatch(
      updatePickup([
        {
          type: 'pickup',
          business_name: loadPoint.businessNamePoint,
          street_address: loadPoint.streetAddressPoint,
          city: loadPoint.cityPoint,
          state: statePoint,
          zip: loadPoint.zipPoint,
          date: pointDate ? moment(pointDate).format('DD.MM.YYYY') : null,
          buyer_number: loadPoint.buyerNumberPoint,
          notes: loadPoint.notesPoint,
          full_name: loadPoint.fullNamePoint,
          phone: phonePoint,
          email: loadPoint.emaiPoint,
          use_custom_date: loadPoint.use_custom_date,
          created_at: loadPoint.created_at,
          custom_date,
          custom_date_format,
        },
        loadId.id,
        copyToCustomer,
      ])
    );
    if (res.type === 'loads/updatePickup/rejected') return setErr(res.payload);

    await dispatch(getLoadData(loadId.id));
    close();
  };

  const pickedAtDate: Date | null = pickedAt
    ? moment(pickedAt, 'MMM D, YYYY h:mm A', true).isValid()
      ? moment(pickedAt, 'MMM D, YYYY h:mm A', true).toDate()
      : null
    : null;

  const selectedDate = loadPoint.use_custom_date ? customDate : pickedAtDate;

  return (
    <ModalPortal>
      <Wrapper ref={refPickup}>
        <Header>
          <LoadsTitle>Edit Pickup</LoadsTitle>
        </Header>
        <Main>
          <LoadsInputField
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <CheckBoxItem>
              <CheckBoxSquare
                type="checkbox"
                name="copyToCustomer"
                id="copyToCustomer"
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  handleCheckboxCopy(e, setCopyToCustomer, copyToCustomer)
                }
                checked={copyToCustomer}
              />
              <CustomCheckBoxSquare>
                <Check right="3px" />
              </CustomCheckBoxSquare>
            </CheckBoxItem>
            <LoadsLabel htmlFor="copyToCustomer" style={{ marginBottom: 0, marginLeft: '12px' }}>
              Copy to Customer
            </LoadsLabel>
          </LoadsInputField>
          <LoadsInputField
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <CheckBoxItem>
              <CheckBoxSquare
                type="checkbox"
                name="use_custom_date"
                id="use_custom_date"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  handleInput(e, setLoadPoint, 'use_custom_date', loadPoint);
                  setShowCustomTime(false);
                }}
                checked={loadPoint.use_custom_date}
              />
              <CustomCheckBoxSquare>
                <Check right="3px" />
              </CustomCheckBoxSquare>
            </CheckBoxItem>
            <LoadsLabel htmlFor="use_custom_date" style={{ marginBottom: 0, marginLeft: '12px' }}>
              Show custom date
            </LoadsLabel>
          </LoadsInputField>
          {loadPoint.use_custom_date && (
            <LoadsInputField
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <CheckBoxItem>
                <CheckBoxSquare
                  type="checkbox"
                  id="use_custom_time"
                  onChange={(e) => setShowCustomTime(e.target.checked)}
                  checked={showCustomTime}
                />
                <CustomCheckBoxSquare>
                  <Check right="3px" />
                </CustomCheckBoxSquare>
              </CheckBoxItem>
              <LoadsLabel htmlFor="use_custom_date" style={{ marginBottom: 0, marginLeft: '12px' }}>
                Show custom time
              </LoadsLabel>
            </LoadsInputField>
          )}
          <LoadsInputField>
            <LoadsLabel htmlFor="businessNamePoint">Business Name</LoadsLabel>
            <LoadsInput
              id="businessNamePoint"
              name="businessNamePoint"
              type="text"
              style={{
                border: err.errors?.business_name?.[0] ? '1px solid #ff0000' : '1px solid #c6c7da',
              }}
              onFocus={() =>
                setErr({
                  ...err,
                  errors: { ...err.errors, business_name: [] },
                })
              }
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                handleInput(e, setLoadPoint, 'businessNamePoint', loadPoint)
              }
              value={loadPoint.businessNamePoint}
            />
            <Error>{err.errors?.business_name?.[0]}</Error>
          </LoadsInputField>
          <LoadsInputField>
            <LoadsLabel htmlFor="streetAddressPoint">Street Address</LoadsLabel>
            <LoadsInput
              id="streetAddressPoint"
              name="streetAddressPoint"
              type="text"
              style={{
                border: err.errors?.street_address?.[0] ? '1px solid #ff0000' : '1px solid #c6c7da',
              }}
              onFocus={() =>
                setErr({
                  ...err,
                  errors: { ...err.errors, street_address: [] },
                })
              }
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                handleInput(e, setLoadPoint, 'streetAddressPoint', loadPoint)
              }
              value={loadPoint.streetAddressPoint}
            />
            <Error>{err.errors?.street_address?.[0]}</Error>
          </LoadsInputField>
          <LoadsFlex>
            <LoadsInputFieldThird>
              <LoadsLabel htmlFor="cityPoint">City</LoadsLabel>
              <LoadsInput
                id="cityPoint"
                name="cityPoint"
                type="text"
                style={{
                  border: err.errors?.city?.[0] ? '1px solid #ff0000' : '1px solid #c6c7da',
                }}
                onFocus={() => setErr({ ...err, errors: { ...err.errors, city: [] } })}
                onChange={(e: ChangeEvent<HTMLInputElement>) => handleInput(e, setLoadPoint, 'cityPoint', loadPoint)}
                value={loadPoint.cityPoint}
              />
              <Error>{err.errors?.city?.[0]}</Error>
            </LoadsInputFieldThird>
            <LoadsInputFieldThird>
              <LoadsLabel htmlFor="statePoint">State</LoadsLabel>
              <SelectedValue
                style={{
                  position: 'absolute',
                  top: '90%',
                  transform: 'translateY(-80%)',
                }}
              >
                {statePoint}
              </SelectedValue>
              <FieldIcon style={{ top: '95%' }}>
                <SelectArrow />
              </FieldIcon>
              <LoadsSelect
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  changeSelectState(e, setStatePoint, setStatePoint)
                }
              >
                <Opt hidden></Opt>
                {americaStates?.map((item: any) => (
                  <Opt key={item} value={item} data-value={item}>
                    {item}
                  </Opt>
                ))}
              </LoadsSelect>
            </LoadsInputFieldThird>
            <LoadsInputFieldThird>
              <LoadsLabel htmlFor="zipPoint">ZIP</LoadsLabel>
              <LoadsInput
                id="zipPoint"
                name="zipPoint"
                type="number"
                onChange={(e: ChangeEvent<HTMLInputElement>) => handleInput(e, setLoadPoint, 'zipPoint', loadPoint)}
                value={loadPoint.zipPoint}
              />
            </LoadsInputFieldThird>
          </LoadsFlex>
          <LoadsFlex>
            <LoadsInputFieldHalf>
              <LoadsLabel htmlFor="pointDate">Scheduled Pickup Date</LoadsLabel>
              <FieldIcon>
                <Calendar />
              </FieldIcon>
              <InputDate
                id="pointDate"
                dateFormat="MM/dd/yyyy"
                style={{ background: 'transparent' }}
                selected={pointDate}
                onChange={(date: Date | null) => setPointDate(date)}
              />
            </LoadsInputFieldHalf>
            <LoadsInputFieldHalf>
              <LoadsLabel htmlFor="pickupOnDate">Picked Up on</LoadsLabel>
              <FieldIcon>
                <Calendar />
              </FieldIcon>
              <InputDate
                disabled={!loadPoint.use_custom_date}
                selected={selectedDate}
                onChange={(date: Date | null) => setCustomDate(date)}
                showTimeSelect={showCustomTime}
                dateFormat={showCustomTime ? 'MM/dd/yyyy HH:mm' : 'MM/dd/yyyy'}
                timeIntervals={15}
                timeFormat="HH:mm"
              />
            </LoadsInputFieldHalf>
          </LoadsFlex>

          <LoadsInputField>
            <LoadsLabel htmlFor="buyerNumberPoint">Buyer Number</LoadsLabel>
            <LoadsInput
              id="buyerNumberPoint"
              name="buyerNumberPoint"
              type="number"
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                handleInput(e, setLoadPoint, 'buyerNumberPoint', loadPoint)
              }
              value={loadPoint.buyerNumberPoint}
            />
          </LoadsInputField>

          <LoadsInputField>
            <LoadsLabel htmlFor="notesPoint">Notes</LoadsLabel>
            <LoadsInputTextArea
              id="notesPoint"
              name="notesPoint"
              rows={4}
              onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                handleInputTextArea(e, setLoadPoint, 'notesPoint', loadPoint)
              }
              value={loadPoint.notesPoint}
            />
          </LoadsInputField>
          <Line />
          <LoadsText>Contact details</LoadsText>
          <LoadsInputField>
            <LoadsLabel htmlFor="fullNamePoint">Full Name</LoadsLabel>
            <LoadsInput
              id="fullNamePoint"
              name="fullNamePoint"
              type="text"
              onChange={(e: ChangeEvent<HTMLInputElement>) => handleInput(e, setLoadPoint, 'fullNamePoint', loadPoint)}
              value={loadPoint.fullNamePoint}
            />
          </LoadsInputField>

          <LoadsFlex>
            <LoadsInputFieldHalf>
              <LoadsLabel htmlFor="phonePoint">Phone</LoadsLabel>
              <InputDiv>
                <PhoneInput
                  international
                  limitMaxLength
                  value={phonePoint}
                  id="phonePoint"
                  onChange={(value: string) => setPhonePoint(value || '')}
                />
              </InputDiv>
            </LoadsInputFieldHalf>
            <LoadsInputFieldHalf>
              <LoadsLabel htmlFor="emaiPoint">Email</LoadsLabel>
              <LoadsInput
                id="emaiPoint"
                name="emaiPoint"
                type="email"
                onChange={(e: ChangeEvent<HTMLInputElement>) => handleInput(e, setLoadPoint, 'emaiPoint', loadPoint)}
                value={loadPoint.emaiPoint}
              />
            </LoadsInputFieldHalf>
          </LoadsFlex>
        </Main>
        <Bottom>
          <Actions>
            <Cancel onClick={close}>Cancel</Cancel>
            <Button text="Save" pad="12px 26px" handleButton={handleConfirm} />
          </Actions>
        </Bottom>
      </Wrapper>
    </ModalPortal>
  );
};

export default PointPickup;
